<template>
  <div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'TransaccionesListenerComponent',
  data () {
    return {
      //
    }
  },
  created () {
    this.$root.$on('update:transacciones', this.onFetch);
    this.$root.$on('update:saldo_id', this.onSaldoId);
  },
  beforeDestroy () {
    this.$root.$off('update:transacciones', this.onFetch);
    this.$root.$off('update:saldo_id', this.onSaldoId);
  },
  computed: {
    ...mapGetters('Cuentas', ['selected', 'filters']),
    cuentaSelected () {
      return this.selected && this.selected.id > 0
    },
    // cuentaId () {
    //   return this.selected.id
    // },
  },
  watch: {
    cuentaSelected(newVal) {
      if(!newVal) {
        this.$store.dispatch('Transacciones/onClearAll');
        this.$store.dispatch('Transacciones/onClearFilters');
      }
    }
  },
  methods: {
    async onSaldoId (payload) {
      this.$store.commit('Transacciones/setFilters', {
        ...this.$store.getters['Transacciones/filters'],
        cuenta_id: payload
      })
      this.$store.dispatch('Transacciones/onFetch');
    },
  }
}
</script>
